import { Injectable } from "@angular/core";

@Injectable()
export class LanguageService {
  public currentLanguage: string = "ES";
  private count: number = 1;

  public exist(lang: string) {
    this.count++;
    if (this.count <= 3) {
        if (this.translations[lang] != undefined) {
            this.currentLanguage = lang;
        } else {
            this.currentLanguage = "EN";
        }
    }
  }

  public translations: object = {
    ES: {
      allqueues: "Todas las colas",
      desk: "Puesto de atención",
      queueEmpty: "La cola está vacía",
      callAction: "Llamar",
      reCallAction: "Rellamar",
      cancelAction: "Cancelar",
      pauseAction: "Pausar",
      recoverAction: "Recuperar",
      historyAction: "Historial de redirecciones",
      noHistory: "El turno no ha sido redirigido",
      redirectAction: "Redirigir",
      redirectInfo: "Va a redirigir el turno",
      redirectError: "Ha ocurrido un error al redirigir a la cola",
      toQueue: "A la cola",
      chooseQueue: "Seleccione una cola / agenda",
      atPosition: "En la posición",
      arrivalOrder: "Orden de llegada",
      startOrder: "Principio de la cola",
      endOrder: "Final de la cola",
      indicatingAtype: "Indicando el tipo de atención",
      observations: "Observaciones",
      attime: "T. Atención",
      waittime: "T. Espera",
      accept: "Aceptar",
      selectAtype: "Seleccione tipo de atención",
      hour: "Hora",
      turn: "Turno",
      preEvaluation: "Preevaluación",
      evaluation: "Evaluación",
      attentionDate: "H. atención",
      recoverTurn: "Recuperar turno",
      queueStatus: "Estado de colas",
      zone : "Zona",
      deskStatus: "Estado de mesas",
      queues: "Colas",
      queue: "Cola",
      refresh: "Refrescar",
      inWait: "En espera",
      waitTime: "T. espera",
      noBodyInAtype:
        "No hay nadie esperando para los tipos de atención que tiene asignados.",
      callTurnInAtype: "Pedir turno de este tipo de atención",
      closeAttention: "Cerrar atención",
      hasNotCome: "No se presenta",
      configuration: "Configuración",
      configurationSaved:
        "Configuración guardada con éxito. Para aplicar los cambios debe refrescar el puesto de atención.",
      refreshDesk: "Refrescar puesto",
      general: "General",
      supervisorMode: "Modo supervisor",
      design: "Apariencia",
      language: "Idioma",
      spanish: "Español",
      english: "Inglés",
      french: "Francés",
      german: "Alemán",
      portuguese: "Portugués",
      italian: "Italiano",
      getTicketToInit: "Solicitar ticket al iniciar",
      recoverFinishedTurn: "Recuperar turno finalizado",
      checkQueue: "Comprobar cola",
      every: "cada",
      seconds: "segundos",
      active: "Activar",
      actionToCallTurn: "Acción al llamar turno",
      evaluateTurnToCall: "Evaluar turno al llamar",
      cancelTurnToCall: "Cancelar turno al llamar",
      colours: "Colores de estado",
      noShow: "No presentado",
      finished: "Finalizado",
      returned: "Devueltos",
      inAttention: "En atención",
      cancelled: "Cancelado",
      save: "Guardar",
      exit: "Salir",
      changeAtype: "Cambiar preevaluación",
      newAtype: "Nuevo tipo de atención",
      noTurn: "Sin turno",
      login: "Identificación",
      selectDesk: "seleccione su puesto de atención",
      user: "Usuario",
      pass: "Contraseña",
      incorrect: "Credenciales incorrectas",
      deskInUse: "Ese puesto de atención ya está en uso",
      join: "entrar",
      atypes: "Tipos",
      turnList: "Listado de turnos",
      redirected: "Redirigido",
      planDate: "F. Cita Previa",
      cclient: "DNI/NIF",
      ccode: "Código",
      client: "Nombre",
      status: "Estado",
      actualQueue: "Cola actual",
      selectOffice: "Seleccione su oficina",
      selectTurnDesk: "Seleccione puesto de atención",
      notifyTitle: "Encólate Desk APP",
      notifyBody: "¡¡Atención!! Hay nuevas personas en la cola",
      notifyTitleTimeExceded: "Encólate Desk APP",
      notifyBodyTimeExceded:
        "La atención actual ha superado el tiempo máximo establecido",
      recoverFinished: "Reencolar",
      ticketDate: "H. ticket",
      redirectDate: "Espera actual",
      selectQueueToWork: "Seleccione con qué cola desea trabajar",
      clientCode: "DNI / Código",
      showCcodeInput: "Mostrar campo de código de cliente",
      maxTime: "Tiempo máximo",
      actualKind: "Tipo de atención",
      columnFilter: "Gestionar columnas",
      moreFilters: "Más filtros",
      resetFilter: "Resetear filtros de columnas",
      specialCode: "Especial",
      personalCode: "Personal",
      textSize: "Tamaño del texto",
      sendNewMessage: "Enviar nuevo mensaje",
      to: "Para",
      message: "Mensaje",
      send: "Enviar",
      sending: "Enviando...",
      sent: "Enviado",
      messageFrom: "Mensaje de",
      emergencyIn: "Emergencia en",
      dateSend: "Enviado el",
      markAsRead: "Marcar como leído",
      reply: "Responder",
      confirmation: "Confirmación de emergencia",
      confirmAlert:
        "¿Realmente desea alertar a otros puestos de una emergencia?",
      yesSendAlert: "Sí, enviar alerta",
      cancel: "Cancelar",
      emergencyButton: "Botón de emergencia",
      notifyEmergency: "¡¡Atención!! Hay una emergencia en ",
      notifyNewMessage: "Tienes un nuevo mensaje de ",
      received: "Recibido",
      alertDefaultMessage:
        "Tengo un problema en mi puesto de atención, por favor, necesito ayuda.",
      phoneAttention: "Atención telefónica",
      enablePhoneAttention: "Habilitar atención telefónica",
      phoneAttentionId: "ID Tipo de atención telefónica",
      enableMessage: "Activar mensajería",
      checkMessage: "Revisar mensajería cada",
      autoReply: "Respuesta automática a mensajes",
      enableAlertButton: "Activar botón de emergencia",
      alertMessage: "Mensaje de emergencia",
      messages: "Mensajería",
      configurationMultiple: "Configuración múltiple",
      checkAll: "Marcar todo",
      unCheckAll: "Desmarcar todo",
      apply: "Aplicar a los puestos seleccionados",
      applied: "Aplicado con éxito",
      task: "Tarea",
      firstAttention: "atendido",
      clearFilters: "Limpiar filtros",
      search: "Buscar...",
      notifyBodyInWaitingPart1: "Le recordamos que tiene en espera a ",
      notifyBodyInWaitingPart2: " personas",
      filter: "Filtrar",
      changePassword: "Cambiar contraseña",
      forbidden: "No tiene permisos",
      nodeskprofile: "La mesa no tiene perfil asignado",
      enterUser: "Introduce tu usuario",
      actualPassword: "Contraseña actual",
      enterActualPassword: "Introduce tu contraseña actual",
      newPassword: "Contraseña nueva",
      enterNewPassword: "Introduce tu nueva contraseña",
      repeatPassword: "Repita su contraseña nueva",
      passwordNotMatch: "Las contraseñas no coinciden",
      passwordSuccess: "Contraseña modificada con éxito",
      invalidUserPassword: "Usuario o contraseña incorrecta",
      historyTurn: "Historial del turno",
      clientData: "Datos del cliente",
      viewObservations: "Observaciones",
      dataUpdated: "Datos actualizados con éxito",
      clientName: "Nombre del cliente",
      nifClient: "DNI del cliente",
      postpone: "Posponer",
      delete: "Eliminar",

      messageDesks: "Mensajería entre mesas",
      sendGlobalMessage: "Enviar mensaje global",
      generalMessage: "Mensaje general de",
      alas: "a las",
      selectOfficeToSend: "Seleccione oficina",
      selectDeskToSend: "Seleccione puestos",
      messageToSend: "Mensaje a enviar",
      messageSended: "Mensaje enviado con éxito",
      online: "Mesas en línea",
      desksOffline: "No hay ningún puesto de atención conectado",
      selectConversation: "Seleccione una conversación para comenzar a chatear",
      queueDesk: "Atención directa",
      toDesk: "Al puesto de atención",
      selectDeskToRedirect: "Seleccione puesto de atención",
      me: "Yo",
      deskIsInactive: "Aviso: el puesto al que deseas redireccionar está inactivo",
      lastViewerCalls: "Últimas llamadas a visores",

      redError: "Ha ocurrido un error de red. Vuelva a intentarlo más tarde.",
      timeExceed: "Has sido desconectado por inactividad.",
      socketInUse: "Su puesto de atención está siendo utilizado por otro usuario, contacte con su administrador para solucionar el problema",

      allCallsViewer: "Últimas llamadas",

      deskprofileError: "No se ha encontrado perfil de desencolado",

      searchatype: "Filtrar tipo de cierre...",

      stopAttention: "Detener atención",
      playAttention: "Continuar atendiendo",

      actuallyStoped: "La atención está actualmente detenida, pulse el botón 'Continuar atendiendo' para reanudar la atención."

    },
    EN: {
      desk: "Desk",
      allqueues: "All queues",
      queueEmpty: "The queue is empty",
      callAction: "Call",
      reCallAction: "Recall",
      cancelAction: "Cancel",
      pauseAction: "Pause",
      recoverAction: "Retrieve",
      historyAction: "Redirect history",
      noHistory: "The turn has not been redirected",
      redirectAction: "Redirect",
      redirectInfo: "You will redirect the turn",
      redirectError: "An error occurred while redirecting to the queue",
      toQueue: "To the queue",
      chooseQueue: "Select a queue / calendar",
      atPosition: "In the position",
      arrivalOrder: "Arrival order",
      startOrder: "Beginning of the queue",
      endOrder: "End of the queue",
      indicatingAtype: "Indicating the kind",
      observations: "Observations",
      attime: "Attention T.",
      waittime: "Wait T.",
      accept: "Accept",
      selectAtype: "Select kind",
      hour: "Hour",
      turn: "Turn",
      preEvaluation: "Pre-evaluation",
      evaluation: "Evaluation",
      attentionDate: "Attention date",
      recoverTurn: "Retrieve turn",
      queueStatus: "Queue status",
      zone : "Zone",
      deskStatus: "Desk status",
      queues: "Queues",
      queue: "Queue",
      refresh: "Refresh",
      inWait: "Waiting",
      waitTime: "Waiting time",
      noBodyInAtype: "There is nobody waiting for the kinds you have assigned.",
      callTurnInAtype: "Call turn of this kind",
      closeAttention: "Close attention",
      hasNotCome: "Has not come",
      configuration: "Configuration",
      configurationSaved:
        "Configuration saved successfully. To apply the changes, you must refresh the desk APP.",
      refreshDesk: "Refresh desk APP",
      general: "General",
      supervisorMode: "Supervisor mode",
      design: "Appearance",
      language: "Language",
      spanish: "Spanish",
      english: "English",
      french: "French",
      german: "German",
      portuguese: "Portuguese",
      italian: "Italian",
      getTicketToInit: "Get ticket when starting",
      recoverFinishedTurn: "Retrieve finished turn",
      checkQueue: "Check queue",
      every: "every",
      seconds: "seconds",
      active: "Active",
      actionToCallTurn: "Action when calling turn",
      evaluateTurnToCall: "Evaluate turn when calling",
      cancelTurnToCall: "Cancel turn when calling",
      colours: "State colors",
      noShow: "Has not come",
      finished: "Finished",
      returned: "Returned",
      inAttention: "In attention",
      cancelled: "Cancelled",
      save: "Save",
      exit: "Exit",
      changeAtype: "Change kind",
      newAtype: "New kind",
      noTurn: "No turn",
      login: "Login",
      selectDesk: "select your desk",
      user: "User",
      pass: "Password",
      incorrect: "Incorrect login",
      deskInUse: "That attention desk is already in use",
      join: "login",
      atypes: "Kinds",
      turnList: "Turn list",
      redirected: "Redirected",
      planDate: "Plan date",
      cclient: "Client ID",
      client: "Client",
      status: "Status",
      actualQueue: "Actual queue",
      selectTurnDesk: "Select desk",
      selectOffice: "Select your office",
      notifyTitle: "Encólate Desk APP",
      notifyBody: "Attention!! There are new people in the queue",
      notifyTitleTimeExceded: "Encólate Desk APP",
      notifyBodyTimeExceded: "You are exceededing the max time",
      recoverFinished: "Return to queue",
      ticketDate: "Ticket date",
      redirectDate: "Current wait",
      selectQueueToWork: "Select queue to work",
      clientCode: "Code",
      showCcodeInput: "Show client code input",
      maxTime: "Max time",
      actualKind: "Kind",
      columnFilter: "More filters",
      moreFilters: "Más filtros",
      resetFilter: "Reset column filter",
      specialCode: "Special",
      personalCode: "Personal",
      textSize: "Text size",
      sendNewMessage: "Send new message",
      to: "To",
      message: "Message",
      send: "Send",
      sending: "Sending...",
      sent: "Sent",
      messageFrom: "Message from",
      emergencyIn: "Emergency in",
      dateSend: "Sent on",
      markAsRead: "Mark as read",
      reply: "Reply",
      confirmation: "Emergency confirmation",
      confirmAlert:
        "Do you really want to alert other positions of an emergency?",
      yesSendAlert: "Yes, send alert",
      cancel: "Cancel",
      emergencyButton: "Emergency button",
      notifyEmergency: "Attention!! There is an emergency in ",
      notifyNewMessage: "You have a new message from ",
      received: "Received",
      alertDefaultMessage:
        "I have a problem at my position, please, I need help.",
      phoneAttention: "Telephone Support",
      enablePhoneAttention: "Enable telephone support",
      phoneAttentionId: "ID Kind of thelephone support",
      enableMessage: "Activate messaging",
      checkMessage: "Check messaging every",
      autoReply: "Automatic reply to messages",
      enableAlertButton: "Activate emergency button",
      alertMessage: "Emergency message",
      messages: "Messenger service",
      configurationMultiple: "Multiple configuration",
      checkAll: "Check all",
      unCheckAll: "Uncheck all",
      apply: "Apply to selected desks",
      applied: "Applied successfully",
      task: "Task",
      firstAttention: "attended",
      clearFilters: "Clear filters",
      search: "Search...",
      notifyBodyInWaitingPart1: "We remind you that you are waiting for ",
      notifyBodyInWaitingPart2: " people",
      filter: "Filter",
      changePassword: "Change password",
      forbidden: "Dont have grants",
      nodeskprofile: "The desk hasn't profile assigned",
      enterUser: "Enter your username",
      actualPassword: "Current password",
      enterActualPassword: "Enter your current password",
      newPassword: "New password",
      enterNewPassword: "Enter your new password",
      repeatPassword: "Repeat your new password",
      passwordNotMatch: "Passwords do not match",
      passwordSuccess: "Password modified successfully",
      invalidUserPassword: "Incorrect user or password",
      historyTurn: "Turns history",
      clientData: "Client data",
      viewObservations: "Observations",
      dataUpdated: "Data updated successfully",
      clientName: "Customer name",
      nifClient: "Client NIF",
      postpone: "Postpone",
      delete: "Delete",
      messageDesks: "Messaging between tables",
      sendGlobalMessage: "Send global message",
      generalMessage: "General Message of",
      alas: "at",
      selectOfficeToSend: "Select office",
      selectDeskToSend: "Select positions",
      messageToSend: "Message to send",
      messageSended: "Message sent succesfully",
      online: "Online",
      desksOffline: "There is no connected service post",
      selectConversation: "Select a conversation to start chatting",
      queueDesk: "Direct attention",
      toDesk: "To attention post",
      selectDeskToRedirect: "Select service post",
      me: "me",
      deskIsInactive: "Notice: the position you want to redirect is inactive",
      lastViewerCalls: "Last calls to viewers",

      redError: "A network error has occurred. Try again later.",
      timeExceed: "You have been disconnected due to inactivity",
      socketInUse: "Your desk is being used by another user, contact your administrator to solve the problem",

      allCallsViewer: "Last calls",

      deskprofileError: "Desk profile not found",

      searchatype: "Filter closure type...",

      stopAttention: "Stop attention",
      playAttention: "Continue attending",

      actuallyStoped: "Attention is currently stopped, press the 'Continue attending' button to resume attention."
    },
    FR: {
      desk: "Bureau",
      allqueues: "Toutes les files d'attente",
      queueEmpty: "La file d'attente est vide",
      callAction: "Appel",
      reCallAction: "Re-Appel",
      cancelAction: "Annuler",
      pauseAction: "Pause",
      recoverAction: "Récupérer",
      historyAction: "Histoire",
      noHistory: "Le tour n'a pas été redirigé",
      redirectAction: "Rediriger",
      redirectInfo: "Vous allez rediriger le virage",
      redirectError:
        "Une erreur s'est produite lors de la redirection vers la file d'attente",
      toQueue: "À la file d'attente",
      chooseQueue: "Sélectionnez une file d'attente / calendrier",
      atPosition: "Dans la position",
      arrivalOrder: "Ordre d'arrivée",
      startOrder: "Début de la file d'attente",
      endOrder: "Fin de la file d'attente",
      indicatingAtype: "Indiquant le genre",
      observations: "Observations",
      attime: "T. d'attention",
      waittime: "T. d'attente",
      accept: "Accepter",
      selectAtype: "Sélectionner un type",
      hour: "Heure",
      turn: "Tournez",
      preEvaluation: "Pré-évaluation",
      evaluation: "Évaluation",
      attentionDate: "Date d'attention",
      recoverTurn: "Retrieve turn",
      queueStatus: "Statut de la file d'attente",
      zone : "Zone",
      deskStatus: "État des tables d'attention",
      queues: "Files d'attente",
      queue: "File d'attente",
      refresh: "Actualiser",
      inWait: "En attente",
      waitTime: "Temps d'attente",
      noBodyInAtype: "Personne n'attend les types que vous avez assignés.",
      callTurnInAtype: "Appel de ce type",
      closeAttention: "Attention particulière",
      hasNotCome: "n'est pas venu",
      configuration: "Configuration",
      configurationSaved:
        "Configuration enregistrée avec succès Pour appliquer les modifications, vous devez actualiser l'application de bureau.",
      refreshDesk: "Refresh desk APP",
      general: "Général",
      supervisorMode: "Mode superviseur",
      design: "Apparence",
      language: "Langue",
      spanish: "Espagnol",
      french: "Français",
      english: "Anglais",
      portuguese: "Portugais",
      german: "Allemand",
      italian: "Italien",
      getTicketToInit: "Obtenir un ticket au démarrage",
      recoverFinishedTurn: "Récupérer le virage terminé",
      checkQueue: "Vérifier la file d'attente",
      every: "tous",
      seconds: "secondes",
      active: "Actif",
      actionToCallTurn: "Action lors de l'appel du virage",
      evaluateTurnToCall: "Evaluer le virage lors de l'appel",
      cancelTurnToCall: "Annuler le virage lors de l'appel",
      colours: "Couleurs d'état",
      noShow: "n'est pas venu",
      finished: "Terminé",
      returned: "Retourné",
      inAttention: "Dans l'attention",
      cancelled: "Annulé",
      save: "Enregistrer",
      exit: "Quitter",
      changeAtype: "Changer de type",
      newAtype: "Nouveau type",
      noTurn: "Liste vide",
      login: "Connexion",
      selectDesk: "Sélectionnez votre bureau",
      user: "Utilisateur",
      pass: "Mot de passe",
      incorrect: "Connexion incorrecte",
      deskInUse: "Ce bureau d'attention est déjà utilisé",
      join: "login",
      atypes: "Sortes",
      turnList: "Tourner la liste",
      redirected: "Redirigé",
      planDate: "Date du plan",
      cclient: "ID client",
      ccode: "Code",
      client: "Client",
      status: "Statut",
      actualQueue: "File d'attente réelle",
      selectTurnDesk: "Sélectionner un bureau",
      selectOffice: "Sélectionnez votre bureau",
      notifyTitle: "Encólate Desk APP",
      notifyBody:
        "Attention !! Il y a de nouvelles personnes dans la file d'attente",
      notifyTitleTimeExceded: "Encólate Desk APP",
      notifyBodyTimeExceded: "Vous dépassez le temps maximum",
      recoverFinished: "Retour à la file d'attente",
      ticketDate: "Date du ticket",
      selectQueueToWork: "Sélectionner la file d'attente pour travailler",
      clientCode: "Code",
      showCcodeInput: "Afficher l'entrée du code client",
      maxTime: "Max time",
      actualKind: "Sorte",
      columnFilter: "Gérer les colonnes",
      moreFilters: "Plus de filtres",
      resetFilter: "Réinitialiser le filtre de colonne",
      specialCode: "Spécial",
      personalCode: "Personnel",
      textSize: "Taille du texte",
      sendNewMessage: "Envoyer un nouveau message",
      to: "à",
      message: "Message",
      send: "Envoyer",
      sending: "Envoi...",
      sent: "Envoyé",
      messageFrom: "Message de",
      emergencyIn: "Urgence",
      dateSend: "Envoyé",
      markAsRead: "Marquer comme lu",
      reply: "Répondre",
      confirmation: "Confirmation d'urgence",
      confirmAlert: "Voulez-vous vraiment alerter les autres postes d'urgence?",
      yesSendAlert: "Oui, envoyer une alerte",
      cancel: "Annuler",
      emergencyButton: "Bouton d'urgence",
      notifyEmergency: "Attention !! Il y a urgence ",
      notifyNewMessage: "Vous avez un nouveau message de ",
      received: "Reçu",
      alertDefaultMessage:
        "J'ai un problème à mon poste, s'il vous plaît, j'ai besoin d'aide.",
      phoneAttention: "Assistance téléphonique",
      enablePhoneAttention: "Activer le support téléphonique",
      phoneAttentionId: "ID Type de support téléphonique",
      enableMessage: "Activer la messagerie",
      checkMessage: "Vérifiez les messages tous les",
      autoReply: "Réponse automatique aux messages",
      enableAlertButton: "Activer le bouton d'urgence",
      alertMessage: "Message d'urgence",
      messages: "Messagerie",
      configurationMultiple: "Configuration multiple",
      checkAll: "Marquer tout",
      unCheckAll: "Décocher tout",
      apply: "Appliquer aux tables sélectionnées",
      applied: "Appliqué avec succès",
      task: "Tâche",
      firstAttention: "assisté",
      clearFilters: "Effacer les filtres",
      search: "Chercher...",
      notifyBodyInWaitingPart1: "Nous vous rappelons que vous attendez ",
      notifyBodyInWaitingPart2: " les gens",
      filter: "Filtrer",

      changePassword: "Changer le mot de passe",
      forbidden: "N'a pas d'autorisations",
      nodeskprofile: "La table n'a pas de profil attribué",
      enterUser: "Entrez votre nom d'utilisateur",
      actualPassword: "Mot de passe actuell",
      enterActualPassword: "Entrez votre mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      enterNewPassword: "Entrez votre nouveau",
      repeatPassword: "Répétez votre nouveau mot de passe",
      passwordNotMatch: "Les mots de passe ne correspondent pas",
      passwordSuccess: "Mot de passe modifié avec succès",
      invalidUserPassword: "Nom d'utilisateur ou mot de passe incorrect",
      historyTurn: "Historique des numéros",
      clientData: "Données des citoyens",
      viewObservations: "Observations",
      dataUpdated: "Données mises à jour avec succès",
      clientName: "Nom du client",
      nifClient: "NIF client",
      postpone: "remettre à plus tard",
      delete: "Supprimer",

      messageDesks: "Messagerie entre tables",
      sendGlobalMessage: "Envoyer un message global",
      generalMessage: "Message général de",
      alas: "à",
      selectOfficeToSend: "Sélectionnez un bureau",
      selectDeskToSend: "Select positions",
      messageToSend: "Sélectionnez des postes",
      messageSended: "message envoyé avec succès",
      online: "Online",
      desksOffline: "Il n'y a pas de poste de service connecté",
      selectConversation: "Sélectionnez une conversation pour commencer à discuter",
      queueDesk: "Attention directe",
      toDesk: "Au poste d'attention",
      selectDeskToRedirect: "Sélectionner un poste de service",
      me: "me",
      deskIsInactive: "Remarque: la position que vous souhaitez rediriger est inactive",
      lastViewerCalls: "Derniers appels aux téléspectateurs",

      redError: "Une erreur réseau s'est produite. Réessayez plus tard.",
      timeExceed: "Vous avez été déconnecté pour cause d'inactivité",
      socketInUse: "Votre bureau est utilisé par un autre utilisateur, contactez votre administrateur pour résoudre le problème",

      allCallsViewer: "Derniers appels",

      deskprofileError: "Profil de bureau introuvable",

      searchatype: "Type de fermeture de filtre...",

      stopAttention: "Arrêtez l'attention",
      playAttention: "Continuer à participer",

      actuallyStoped: "L'attention est actuellement arrêtée, appuyez sur le bouton « Continuer l'attention » pour reprendre l'attention."
    },
    PT: {
      desk: "Mesa",
      allqueues: "Todas as filas",
      queueEmpty: "A fila está vazia",
      callAction: "Ligar",
      reCallAction: "Re-Ligar",
      cancelAction: "Cancelar",
      pauseAction: "Pause",
      recoverAction: "Recuperar",
      historyAction: "História",
      noHistory: "O turn não foi redirecionado",
      redirectAction: "Redirect",
      redirectInfo: "Irá redirecionar o turn",
      redirectError: "Ocorreu um erro ao redirecionar para a fila",
      toQueue: "Para a cauda",
      chooseQueue: "Selecione uma fila / agenda",
      atPosition: "Em posição",
      arrivalOrder: "Ordem de chegada",
      startOrder: "Início da fila",
      endOrder: "Fim da fila",
      indicatingAtype: "Indicando o tipo de atenção",
      observations: "Observações",
      attime: "T. atenção",
      waittime: "T. espera",
      accept: "Aceitar",
      selectAtype: "Selecione o tipo de atenção",
      hour: "Hora",
      turn: "Turn",
      preEvaluation: "Pré-avaliação",
      Evaluation: "Avaliação",
      attentionDate: "N. atenção",
      recoverTurn: "Recuperar deslocamento",
      queueStatus: "Estado das filas",
      zone : "Zona",
      deskStatus: "Estado das tabelas de atenção",
      queues: "Colas",
      queue: "Cola",
      refresh: "Atualizar",
      inWait: "Em espera",
      waitTime: "T. espera",
      noBodyInAtype:
        "Não há ninguém esperando pelos tipos de atenção atribuídos a você.",
      callTurnInAtype: "Peça esse tipo de atenção",
      closeAttention: "Atenção apertada",
      hasNotCome: "Não aparece",
      configuration: "Configuração",
      configurationSaved:
        "Configuração salva com sucesso. Para aplicar as mudanças você deve atualizar a tabela.",
      refreshDesk: "Atualizar tabela",
      general: "Geral",
      supervisorMode: "Modo de supervisor",
      design: "Aparência",
      language: "Language",
      spanish: "Espanhol",
      english: "Inglês",
      french: "Francês",
      portuguese: "Portugues",
      german: "Alemão",
      italian: "Italiano",
      getTicketToInit: "Solicitar ticket ao iniciar",
      recoverFinishedTurn: "Recuperar deslocamento concluído",
      checkQueue: "Fila de verificação",
      every: "cada",
      seconds: "segundos",
      active: "Ativar",
      actionToCallTurn: "Ação ao chamar vire",
      evaluateTurnToCall: "Avaliar virar ao chamar",
      cancelTurnToCall: "Cancelar vez ao chamar",
      colours: "Cores do estado",
      noShow: "Não apresentado",
      finished: "Concluído",
      returned: "Devolvido",
      inAttention: "Em atenção",
      cancelled: "Cancelado",
      save: "Salvar",
      exit: "Exit",
      changeAtype: "Alterar tipo",
      newAtype: "Novo tipo de atenção",
      noTurn: "Não há turno",
      login: "Identificação",
      selectDesk: "selecione sua tabela",
      user: "Usuário",
      pass: "Senha",
      incorrect: "credenciais incorretas",
      deskInUse: "Esse balcão de atendimento já está em uso",
      join: "enter",
      atypes: "Tipos",
      turnList: "Lista de turnos",
      redirected: "Redirecionado",
      planDate: "D. do compromisso anterior",
      cclient: "C. do cliente",
      ccode: "Code",
      client: "Cliente",
      status: "Status",
      actualQueue: "Fila atual",
      selectTurnDesk: "Selecione a mesa de trabalho",
      selectOffice: "Selecione seu escritório",
      notifyTitle: "Encólate Desk APP",
      notifyBody: "Atenção !! Há novas pessoas na fila",
      notifyTitleTimeExceded: "Encólate Desk APP",
      notifyBodyTimeExceded:
        "A atenção atual excedeu o tempo máximo estabelecido",
      recoverFinished: "Re-link",
      ticketDate: "D. do bilhete",
      selectQueueToWork: "Selecione com qual fila você quer trabalhar",
      clientCode: "Code",
      showCcodeInput: "Mostrar campo do código do cliente",
      maxTime: "Tempo máximo",
      actualKind: "Tipo de atenção",
      columnFilter: "Gerenciar colunas",
      moreFilters: "Mais filtros",
      resetFilter: "Redefinir filtros de coluna",
      specialCode: "Especial",
      personalCode: "Cajado",
      textSize: "Tamanho do texto",
      sendNewMessage: "Enviar nova mensagem",
      to: "Para",
      message: "Mensagem",
      send: "Enviar",
      sending: "Enviando...",
      sent: "Enviado",
      messageFrom: "Mensagem de",
      emergencyIn: "Emergência em",
      dateSend: "Enviado em",
      markAsRead: "Marcar como lida",
      reply: "Responder",
      confirmation: "Confirmação de emergência",
      confirmAlert:
        "Você realmente quer alertar outras posições de uma emergência?",
      yesSendAlert: "Sim, enviar alerta",
      cancel: "Cancelar",
      emergencyButton: "Botão de emergência",
      notifyEmergency: "Atenção !! Há uma emergência em ",
      notifyNewMessage: "Você tem uma nova mensagem de ",
      received: "Recebido",
      alertDefaultMessage:
        "Eu tenho um problema na minha posição, por favor, eu preciso de ajuda.",
      phoneAttention: "Suporte por telefone",
      enablePhoneAttention: "Ativar suporte por telefone",
      phoneAttentionId: "ID Tipo de suporte telefônico",
      enableMessage: "Ativar mensagens",
      checkMessage: "Verifique todas as mensagens",
      autoReply: "Resposta automática a mensagens",
      enableAlertButton: "Ativar botão de emergência",
      alertMessage: "Mensagem de emergência",
      messages: "Mensagens",
      configurationMultiple: "Configuração múltipla",
      checkAll: "Marcar tudo",
      unCheckAll: "Desmarque todos",
      apply: "Aplicar a tabelas selecionadas",
      applied: "Aplicado com sucesso",
      task: "Tarefa",
      firstAttention: "participaram",
      clearFilters: "Limpar filtros",
      search: "Procurar...",
      notifyBodyInWaitingPart1: "Lembramos que você está esperando por ",
      notifyBodyInWaitingPart2: " pessoas",
      filter: "Filtrar",

      changePassword: "Alterar senha",
      forbidden: "Não tem permissões",
      nodeskprofile: "A mesa não tem nenhum perfil atribuído",
      enterUser: "Digite seu nome de usuário",
      actualPassword: "Senha atual",
      enterActualPassword: "Digite sua senha atual",
      newPassword: "Nova senha",
      enterNewPassword: "Digite sua nova senha",
      repeatPassword: "Repita sua nova senha",
      passwordNotMatch: "As senhas não correspondem",
      passwordSuccess: "Senha modificada com sucesso",
      invalidUserPassword: "Nome de usuário ou senha incorretos",

      historyTurn: "histórico de ingressos",
      clientData: "Dados do cliente",
      viewObservations: "Observações",
      dataUpdated: "Dados atualizados com sucesso",
      clientName: "Nome do cliente",
      nifClient: "NIF do cliente",
      postpone: "Postergar",
      delete: "Excluir",

      messageDesks: "Mensagens entre tabelas",
      sendGlobalMessage: "Enviar mensagem global",
      generalMessage: "Mensagem Geral de",
      alas: "às",
      selectOfficeToSend: "Selecionar escritório",
      selectDeskToSend: "Selecionar posições",
      messageToSend: "Mensagem para enviar",
      messageSended: "Mensagem enviada com sucesso",
      online: "Online",
      desksOffline: "Não há posto de serviço conectado",
      selectConversation: "Selecione uma conversa para começar a conversar",
      queueDesk: "Atenção direta",
      toDesk: "Para o posto de atenção",
      selectDeskToRedirect: "Selecionar posto de serviço",
      me: "me",
      deskIsInactive: "Aviso: a posição que você deseja redirecionar está inativa",
      lastViewerCalls: "Últimas chamadas para os espectadores",

      redError: "Ocorreu um erro de rede. Tente novamente mais tarde.",
      timeExceed: "A été déconnecté pour inactivité",
      socketInUse: "Sua mesa está sendo usada por outro usuário, entre em contato com o administrador para resolver o problema",

      allCallsViewer: "Últimas chamadas",

      deskprofileError: "Perfil de mesa não encontrado",

      searchatype: "Tipo de fechamento do filtro...",

      stopAttention: "Pare a atenção",
      playAttention: "Continue participando",

      actuallyStoped: "A atenção está interrompida no momento, pressione o botão 'Continuar participando' para retomar a atenção."
    },
    DE: {
      desk: "Tisch",
      allqueues: "Alle Warteschlangen",
      queueEmpty: "Die Warteschlange ist leer",
      callAction: "Anrufen",
      reCallAction: "Re-Anrufen",
      cancelAction: "Abbrechen",
      pauseAction: "Pause",
      recoverAction: "Wiederherstellen",
      historyAction: "Geschichte",
      noHistory: "Die Runde wurde nicht umgeleitet",
      redirectAction: "Weiterleiten",
      redirectInfo: "Es wird die Runde umgeleitet",
      redirectError:
        "Beim Umleiten in die Warteschlange ist ein Fehler aufgetreten",
      toQueue: "Zum Schwanz",
      chooseQueue: "Wählen Sie eine Warteschlange / Tagesordnung",
      atPosition: "In der position",
      arrivalOrder: "Reihenfolge der Ankunft",
      startOrder: "Beginn der Warteschlange",
      endOrder: "Ende der Warteschlange",
      indicatingAtype: "Angabe der Art der Aufmerksamkeit",
      observations: "Beobachtungen",
      attime: "Aufmerksamkeitszeit",
      waittime: "Wartezeit",
      accept: "Akzeptieren",
      selectAtype: "Art der Aufmerksamkeit auswählen",
      hour: "Zeit",
      turn: "Drehen",
      preEvaluation: "Vorevaluation",
      evaluation: "Evaluation",
      attentionDate: "D. Aufmerksamkeit",
      recoverTurn: "Schicht abrufen",
      queueStatus: "Status der Warteschlangen",
      zone : "Zone",
      deskStatus: "Zustand der Aufmerksamkeitstabellen",
      queues: "Schwänze",
      queue: "Schwänze",
      refresh: "Aktualisieren",
      inWait: "Warte",
      waitTime: "Standby-Zeit",
      noBodyInAtype:
        "Es wartet niemand auf die Aufmerksamkeit, die Ihnen zugewiesen wurde.",
      callTurnInAtype: "Fragen Sie nach dieser Art von Aufmerksamkeit",
      closeAttention: "Aufmerksam",
      hasNotCome: "Wird nicht angezeigt",
      configuration: "Konfiguration",
      configurationSaved:
        "Die Konfiguration wurde erfolgreich gespeichert. Um die Änderungen zu übernehmen, müssen Sie die Tabelle aktualisieren.",
      refreshDesk: "Tabelle aktualisieren",
      general: "Allgemein",
      supervisorMode: "Supervisor-Modus",
      design: "Aussehen",
      language: "Sprache",
      spanish: "Spanisch",
      english: "Englisch",
      french: "Französisch",
      portuguese: "Portugiesisch",
      german: "Deutsch",
      italian: "Italienisch",
      getTicketToInit: "Ticket beim Start anfordern",
      recoverFinishedTurn: "Schicht abrufen abgeschlossen",
      checkQueue: "Check Queue",
      every: "jeder",
      seconds: "sekunden",
      active: "Aktivieren",
      actionToCallTurn: "Aktion beim Aufruf drehen",
      evaluateTurnToCall: "Turn beim Aufruf auswerten",
      cancelTurnToCall: "Abbruch beim Aufruf",
      colours: "Staatsfarben",
      noShow: "Nicht präsentiert",
      finished: "Fertig",
      returned: "Zurückgegeben",
      inAttention: "In Aufmerksamkeit",
      cancelled : "Abgesagt",
      save: "Speichern",
      exit: "Ausgang",
      changeAtype: "Typ ändern",
      newAtype: "Neue Art von Aufmerksamkeit",
      noTurn: "Keine Verschiebung",
      login: "Identifikation",
      selectDesk: "Wählen Sie Ihre Tabelle",
      user: "Benutzer",
      pass: "Passwort",
      incorrect: "Falsche Anmeldedaten",
      deskInUse: "Dieser Aufmerksamkeitsschalter wird bereits verwendet",
      join: "eingeben",
      atypes: "Typen",
      turnList: "Liste der Verschiebungen",
      redirected: "Umgeleitet",
      planDate: "Termin vor dem Termin",
      cclient: "Client-Code",
      ccode: "Code",
      client: "Kunde",
      status: "Staat",
      actualQueue: "Aktuelle Warteschlange",
      selectTurnDesk: "Wählen Sie die Arbeitstabelle aus",
      selectOffice: "Wählen Sie Ihr Büro aus",
      notifyTitle: "Encólate Desk APP",
      notifyBody: "Achtung! Es sind neue Leute in der Warteschlange",
      notifyTitleTimeExceded: "Encólate Desk APP",
      notifyBodyTimeExceded:
        "Die aktuelle Pflege hat die festgelegte Höchstzeit überschritten",
      recoverFinished: "Wiederverbindung",
      ticketDate: "Ticketdatum",
      selectQueueToWork:
        "Wählen Sie die Warteschlange aus, mit der Sie arbeiten möchten",
      clientCode: "Code",
      showCcodeInput: "Zeige Client-Code-Feld",
      maxTime: "Maximale Zeit",
      actualKind: "Art der Aufmerksamkeit",
      columnFilter: "Spalten verwalten",
      moreFilters: "Weitere Filter",
      resetFilter: "Spaltenfilter zurücksetzen",
      specialCode: "Spezial",
      personalCode: "Personal",
      textSize: "Textgröße",
      sendNewMessage: "Neue Nachricht senden",
      to: "Zu",
      message: "Nachricht",
      send: "Senden",
      sending: "Senden...",
      sent: "Gesendet",
      messageFrom: "Nachricht von",
      emergencyIn: "Notfall in",
      dateSend: "Gesendet",
      markAsRead: "Als gelesen markieren",
      reply: "Antwort",
      confirmation: "Notfallbestätigung",
      confirmAlert:
        "Willst du wirklich andere Positionen eines Notfalls alarmieren?",
      yesSendAlert: "Ja, Alarm senden",
      cancel: "Abbrechen",
      emergencyButton: "Notruftaste",
      notifyEmergency: "Achtung !! Es ist ein Notfall eingetreten ",
      notifyNewMessage: "Sie haben eine neue Nachricht von ",
      received: "Erhalten",
      alertDefaultMessage:
        "Ich habe ein Problem in meiner Position, bitte, ich brauche Hilfe.",
      phoneAttention: "Telefonischer Support",
      enablePhoneAttention: "Telefonunterstützung aktivieren",
      phoneAttentionId: "ID Art der Telefonunterstützung",
      enableMessage: "Aktivieren Sie das Messaging",
      checkMessage: "Überprüfe alle Nachrichten",
      autoReply: "Automatische Antwort auf Nachrichten",
      enableAlertButton: "Aktivieren Sie den Notfallknopf",
      alertMessage: "Notfallmeldung",
      messages: "Nachrichten",
      configurationMultiple: "Mehrfachkonfiguration",
      checkAll: "Alle markieren",
      unCheckAll: "Deaktivieren Sie alle",
      apply: "Auf ausgewählte Tabellen anwenden",
      applied: "Erfolgreich angewendet",
      task: "Aufgabe",
      firstAttention: "besucht",
      clearFilters: "Filter löschen",
      search: "Suche...",
      notifyBodyInWaitingPart1: "Wir erinnern Sie daran, dass Sie darauf warten ",
      notifyBodyInWaitingPart2: " Menschen",
      filter: "Filter",
      changePassword: "Passwort ändern",
      forbidden: "Hat keine Berechtigungen",
      nodeskprofile: "Der Tabelle ist kein Profil zugeordnet",
      enterUser: "Geben Sie Ihren Benutzernamen ein",
      actualPassword: "Aktuelles Passwort",
      enterActualPassword: "Geben Sie Ihr aktuelles Passwort ein",
      newPassword: "Neues Passwort",
      enterNewPassword: "Geben Sie Ihr neues Passwort",
      repeatPassword: "Wiederholen Sie Ihr neues Passwort",
      passwordNotMatch: "Passwörter stimmen nicht überein",
      passwordSuccess: "Passwort erfolgreich geändert",
      invalidUserPassword: "Falscher Benutzername oder falsches Passwort",
      historyTurn: "Tickets Geschichte",
      clientData: "Kundendaten",
      viewObservations: "Anzeigen",
      dataUpdated: "Daten wurden erfolgreich aktualisiert",
      clientName: "Kundenname",
      nifClient: "Client-NIF",
      postpone: "Verschieben",
      delete: "Löschen",
      messageDesks: "Nachrichten zwischen Tabellen",
      sendGlobalMessage: "Globale Nachricht senden",
      generalMessage: "Allgemeine Botschaft von",
      alas: "beim",
      selectOfficeToSend: "Büro auswählen",
      selectDeskToSend: "Positionen auswählen",
      messageToSend: "Nachricht zum Senden",
      messageSended: "Nachricht erfolgreich gesendet",
      online: "Online",
      desksOffline: "Es gibt keine verbundene Service-Post",
      selectConversation: "Wählen Sie eine Konversation aus, um mit dem Chatten zu beginnen",
      queueDesk: "Direkte Aufmerksamkeit",
      toDesk: "Zum Aufmerksamkeitsposten",
      selectDeskToRedirect: "Service-Post auswählen",
      me: "me",
      deskIsInactive: "Hinweis: Die Position, die Sie umleiten möchten, ist inaktiv",
      lastViewerCalls: "Letzte Anrufe bei den Zuschauern",

      redError: "Ein Netzwerkfehler ist aufgetreten. Versuchen Sie es später erneut.",
      timeExceed: "Sie wurden aufgrund von Inaktivität getrennt",
      socketInUse: "Ihr Schreibtisch wird von einem anderen Benutzer verwendet. Wenden Sie sich an Ihren Administrator, um das Problem zu lösen.",

      allCallsViewer: "Letzte Anrufe",

      deskprofileError: "Schreibtischprofil nicht gefunden",

      searchatype: "Filterverschlusstyp...",

      stopAttention: "Achtung stoppen",
      playAttention: "Weiter teilnehmen",

      actuallyStoped: "Die Aufmerksamkeit wird derzeit unterbrochen. Drücken Sie die Schaltfläche 'Weiter teilnehmen', um die Aufmerksamkeit wieder aufzunehmen."
    },
    IT: {
      desk: "Tavolo",
      allqueues: "Tutte le code",
      queueEmpty: "La coda è vuota",
      callAction: "Chiamata",
      reCallAction: "Chiama di nuovo",
      cancelAction: "Annullare",
      pauseAction: "Pausa",
      recoverAction: "Recuperare",
      historyAction: "Record",
      noHistory: "Il turno non è stato reindirizzato",
      redirectAction: "Reindirizzamento",
      redirectInfo: "Reindirizzerai il turno",
      redirectError:
        "Si è verificato un errore durante il reindirizzamento alla coda",
      toQueue: "Alla coda",
      chooseQueue: "Seleziona una coda / diario",
      atPosition: "Nella posizione",
      arrivalOrder: "Ordine di arrivo",
      startOrder: "Inizio della coda",
      endOrder: "Fine della coda",
      indicatingAtype: "Indicazione del tipo di attenzione",
      observations: "Osservazioni",
      attime: "T. attenzione",
      waittime: "T. attesa",
      accept: "Accettare",
      selectAtype: "Seleziona il tipo di servizio",
      hour: "Tempo",
      turn: "Turno",
      preEvaluation: "Prescreening",
      evaluation: "Escreening",
      attentionDate: "Data di attenzione",
      recoverTurn: "Recupera turno",
      queueStatus: "Stato della coda",
      zone : "Zona",
      deskStatus: "Stato delle tabelle di attenzione",
      queues: "Codes",
      queue: "Code",
      refresh: "Rinfrescare",
      inWait: "In attesa di",
      waitTime: "Tempo di attesa",
      noBodyInAtype:
        "Non c'è nessuno in attesa dei tipi di attenzione assegnati a loro.",
      callTurnInAtype: "Chiedi questo tipo di attenzione",
      closeAttention: "Molta attenzione",
      hasNotCome: "Non si presenta",
      configuration: "Configurazione",
      configurationSaved:
        "Configurazione salvata correttamente. Per applicare le modifiche, è necessario aggiornare la tabella.",
      refreshDesk: "Aggiorna tabella",
      general: "Generale",
      supervisorMode: "Modalità supervisore",
      design: "Aspetto",
      language: "Lingua",
      spanish: "Spagnolo",
      english: "Inglese",
      french: "Francese",
      german: "Tedesco",
      portuguese: "Portoghese",
      italian: "Italiano",
      getTicketToInit: "Richiedi il ticket all'avvio",
      recoverFinishedTurn: "Recupera il turno finito",
      checkQueue: "Controlla la coda",
      every: "ogni",
      seconds: "secondi",
      active: "Attivare",
      actionToCallTurn: "Azione quando si chiama la svolta",
      evaluateTurnToCall: "Valuta la svolta quando chiami",
      cancelTurnToCall: "Annulla la svolta quando chiami",
      colours: "Colori dello stato",
      noShow: "Non presentato",
      finished: "Finalizzato",
      returned: "Tornato",
      inAttention: "In attenzione",
      cancelled: "Annullato",
      save: "Salvare",
      exit: "Uscita",
      changeAtype: "Cambia tipo di attenzione",
      newAtype: "Nuovo tipo di attenzione",
      noTurn: "Nessun turno",
      login: "Identificazione",
      selectDesk: "Seleziona il tuo tavolo",
      user: "Utente",
      pass: "Password",
      incorrect: "Cattive credenziali",
      deskInUse: "Quel banco dell'attenzione è già in uso",
      join: "Entrare",
      atypes: "Tipi di cura",
      turnList: "Elenco di turni",
      redirected: "Reindirizzato",
      planDate: "Data di appuntamento precedente",
      cclient: "Codice cliente",
      ccode: "Codice",
      client: "Cliente",
      status: "Stato",
      actualQueue: "Coda corrente",
      selectTurnDesk: "Seleziona la tabella di lavoro",
      selectOffice: "Seleziona il tuo ufficio",
      notifyTitle: "Encólate Desk APP",
      notifyBody: "Attenzione !! Ci sono nuove persone in coda",
      notifyTitleTimeExceded: "Encólate Desk APP",
      notifyBodyTimeExceded:
        "La cura attuale ha superato il tempo massimo stabilito",
      recoverFinished: "Riaccodamento",
      ticketDate: "Data del biglietto",
      selectQueueToWork: "Seleziona la coda con cui vuoi lavorare",
      clientCode: "Codice",
      showCcodeInput: "Mostra campo codice cliente",
      maxTime: "Tempo massimo",
      actualKind: "Tipo di attenzione",
      columnFilter: "Gestire le colonne",
      moreFilters: "Più filtri",
      resetFilter: "Reimposta i filtri delle colonne",
      specialCode: "Speciale",
      personalCode: "Personale",
      textSize: "Dimensione del testo",
      sendNewMessage: "Invia nuovo messaggio",
      to: "A",
      message: "Messaggio",
      send: "Invia",
      sending: "Invio in corso...",
      sent: "Inviato",
      messageFrom: "Messaggio da",
      emergencyIn: "Emergenza in",
      dateSend: "Inviato su",
      markAsRead: "Segna come già letto",
      reply: "Rispondi",
      confirmation: "Conferma di emergenza",
      confirmAlert: "Vuoi davvero avvisare altre posizioni di un'emergenza?",
      yesSendAlert: "Sì, invia avviso",
      cancel: "Annulla",
      emergencyButton: "Attenzione !! C'è un'emergenza in",
      notifyEmergency: "Attention!! There is an emergency in ",
      notifyNewMessage: "Hai un nuovo messaggio da ",
      received: "Ricevuto",
      alertDefaultMessage:
        "Ho un problema nella mia posizione, per favore, ho bisogno di aiuto.",
      phoneAttention: "Supporto telefonico",
      enablePhoneAttention: "Abilita supporto telefonico",
      phoneAttentionId: "ID Tipo di supporto per telefono",
      enableMessage: "Attiva la messaggistica",
      checkMessage: "Controlla tutti i messaggi",
      autoReply: "Risposta automatica ai messaggi",
      enableAlertButton: "Attiva il pulsante di emergenza",
      alertMessage: "Messaggio di emergenza",
      messages: "Messaggistica",
      configurationMultiple: "Configurazione multipla",
      checkAll: "Segna tutti",
      unCheckAll: "Deseleziona tutto",
      apply: "Applica alle tabelle selezionate",
      applied: "Applicato con successo",
      task: "Compito",
      firstAttention: "frequentato",
      clearFilters: "Cancella i filtri",
      search: "Ricerca...",
      notifyBodyInWaitingPart1: "Ti ricordiamo che stai aspettando ",
      notifyBodyInWaitingPart2: " persone",
      filter: "Filtro",
      changePassword: "Cambia password",
      forbidden: "Non dispone delle autorizzazioni",
      nodeskprofile: "La tabella non ha alcun profilo assegnato",
      enterUser: "Inserisci il tuo nome utente",
      actualPassword: "Password attuale",
      enterActualPassword: "Inserisci la tua password attuale",
      newPassword: "Nuova password",
      enterNewPassword: "Inserisci la tua nuova password",
      repeatPassword: "Ripeti la tua nuova password",
      passwordNotMatch: "Le password non corrispondono",
      passwordSuccess: "Password modificata correttamente",
      invalidUserPassword: "Nome utente o password errati",
      historyTurn: "Cronologia dei biglietti",
      clientData: "Dati del cliente",
      viewObservations: "Osservazioni",
      dataUpdated: "Dati aggiornati correttamente",
      clientName: "Nome del cliente",
      nifClient: "Client NIF",
      postpone: "Rinviare",
      delete: "Elimina",
      messageDesks: "Messaggi tra le tabelle",
      sendGlobalMessage: "Invia un messaggio globale",
      generalMessage: "Messaggio generale di",
      alas: "a",
      selectOfficeToSend: "Seleziona l'ufficio",
      selectDeskToSend: "Seleziona posizioni",
      messageToSend: "Messaggio da inviare",
      messageSended: "Messaggio inviato con successo",
      online: "Online",
      desksOffline: "Non è presente alcun servizio post collegato",
      selectConversation: "Seleziona una conversazione per iniziare a chattare",
      queueDesk: "Attenzione diretta",
      toDesk: "Al messaggio di attenzione",
      selectDeskToRedirect: "Seleziona servizio post",
      me: "me",
      deskIsInactive: "Avviso: la posizione che si desidera reindirizzare è inattiva",
      lastViewerCalls: "Ultime chiamate agli spettatori",

      redError: "Si è verificato un errore di rete. Riprovare più tardi.",
      timeExceed: "Sei stato disconnesso per inattività",
      socketInUse: "La tua scrivania è utilizzata da un altro utente, contatta il tuo amministratore per risolvere il problema",

      allCallsViewer: "Ultime chiamate",

      deskprofileError: "Profilo scrivania non trovato",

      searchatype: "Tipo di chiusura del filtro...",

      stopAttention: "Stop all'attenzione",
      playAttention: "Continua a partecipare",

      actuallyStoped: "L'attenzione è attualmente interrotta, premi il pulsante 'Continua a partecipare' per ripristinare l'attenzione."
    }
  };

  constructor() {}

  /* Get translation */
  public getTranslation(value: string): string {
    return this.translations[this.currentLanguage][value];
  }
}
